import * as core from '../../../../../../../core'
import * as stakeholderAnalysis from '../stakeholder-analysis'

export const RESOURCE = {
  payload: {
    alias: 'stakeholders',
    appAlias: stakeholderAnalysis.RESOURCE.payload.alias,
    description: 'Filterable list of stakeholders',
    display: {
      isMain: true,
      position: 3,
    },
    name: 'Stakeholders',
    page: { alias: 'stakeholders' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
